import React from "react";
import { useTranslation } from "react-i18next";

import Radio from "@is/components/Radio";
import { PhoneOrEmailInputField, TranslationContext } from "@is/constants";

import css from "./PhoneOrEmailLabel.module.css";

type Props = {
  fieldName: PhoneOrEmailInputField;
  onChange: (name: PhoneOrEmailInputField) => void;
  isRequired?: boolean;
  hasError?: boolean;
};

const PhoneOrEmailLabel = ({
  fieldName,
  onChange,
  isRequired,
  hasError,
}: Props) => {
  const { t } = useTranslation(TranslationContext.Checkout);

  return (
    <div className={css.container}>
      <Radio
        checked={fieldName === PhoneOrEmailInputField.Phone}
        onChange={onChange}
        title={t("Phone number")}
        name={PhoneOrEmailInputField.Phone}
        isRequired={isRequired}
        hasError={hasError}
      />
      <Radio
        checked={fieldName === PhoneOrEmailInputField.Email}
        onChange={onChange}
        title={t("Email")}
        name={PhoneOrEmailInputField.Email}
        isRequired={isRequired}
        hasError={hasError}
      />
    </div>
  );
};
export default PhoneOrEmailLabel;
